import styled from 'styled-components';

import { Checkbox } from '@gympass/yoga';

export const StyledCheckbox = styled(Checkbox)`
  > div {
    > label {
      font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
      line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
      color: ${({ theme }) => theme.yoga.colors.textSecondary};
      text-align: left;

      > div {
        border-color: ${props =>
          props.theme.yoga.colors[
            (props.hasError && 'error') ||
              (props.disabled && 'elements.backgroundAndDisabled') ||
              'primary'
          ]};

        & svg {
          fill: ${props => props.disabled && props.theme.yoga.colors.medium};
        }
      }
    }

    &:focus {
      outline: 0;
    }

    &:focus-within,
    &:hover {
      > label {
        span {
          background-color: ${({ theme }) =>
            theme.yoga.colors.primaryLight} !important;
          box-shadow: 0 0 0 8px ${({ theme }) => theme.yoga.colors.primaryLight} !important;
        }
      }
    }

    > label > div:not(:empty) {
      background-color: ${props =>
        !props.disabled && props.theme.yoga.colors.primary};
    }
  }
`;
